export default {
  tipsOne:
    '1. Będziemy przechowywać towary bezpłatnie przez 90 dni. Jeśli nie złożysz paczki lub nie podejmiesz żadnych działań po 90 dniach, zostanie to uznane za rezygnację z towarów i zostaną one zniszczone.',
  tipsTwo: '2. Towary zostały umieszczone w magazynie, możesz w każdej chwili wejść do swojego magazynu i przesłać na swój zagraniczny adres dostawy',
  orderDetail: 'Szczegóły zamówienia',
  orderNo: 'Nr zamówienia',
  orderConsult: 'Pomoc z zamówieniem',
  consult: 'Zapytanie',
  orderConsultTips:
    'Agent zakupowy może obsługiwać tylko sprawy związane z tym zamówieniem. W przypadku innych zapytań biznesowych prosimy o kontakt',
  enquiryReplyMsg:
    'Wpisz tutaj, odpowiemy w ciągu 24 godzin. (Uwaga: Czasami używamy oprogramowania do tłumaczenia, które może nie przekazywać dokładnie znaczenia, prosimy o wyrozumiałość)',
  stepListEnum: {
    '-1': 'Wybierz produkty',
    0: 'Złóż paczkę',
    6: 'Opłać przesyłkę',
    9: 'Wyślij paczkę',
    20: 'Potwierdź odbiór'
  }
};